export const STORAGE_KEYS = {
  USERINFO: 'loginInfo',  // userInfo 변경하기
}

export const DEFAULT_MENU = 'prescriptionMgt'
